export enum Role {
  User = 'User',
  Admin = 'Admin',
  SuperAdmin = 'SuperAdmin',
  ClinicAdmin = 'ClinicAdmin',
  Moderator = 'Moderator',
}
